import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import { Text } from 'rebass';
import { ModalClose, ModalButton } from 'shared/modals';
import { ModalContainer } from 'shared/modals/v2-container';
import useStores from 'shared/hooks/use-stores';
var PhoneNumberConfirmationModal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var containerProps = _ref.containerProps;
  var _useStores = useStores(),
    UI = _useStores.UI,
    User = _useStores.User,
    Cart = _useStores.Cart;
  var resolve = UI.phoneNumberConfirmationObj.resolve;
  function onConfirm(result) {
    UI.phoneNumberConfirmationObj.confirmed = true;
    resolve(result);
    UI.phoneNumberConfirmationObj.open = false;
  }
  var customerPhone = Cart.order.guestCustomer ? Cart.order.guestCustomer.phone : User.profile.phone;
  return useObserver(function () {
    if (!UI.phoneNumberConfirmationObj.open) {
      return null;
    }
    return __jsx(ModalContainer, _extends({
      ref: ref,
      padding: "31px 0px 45px 0px",
      scrollable: true,
      isOpen: true,
      width: 495,
      "data-cy": "confirm-number-modal",
      "data-test": "confirm-number-modal",
      "data-testid": "confirm-number-modal"
    }, containerProps), __jsx(ModalContent, null, __jsx(StyledModalHeader, null, "Confirm Your Phone Number"), __jsx(StyledText, null, "It's important that we have the correct mobile phone number in case we need to contact you about your order."), __jsx(LargeText, {
      "data-testid": "customer-phone-number"
    }, customerPhone), __jsx(StyledModalButton, {
      "aria-label": "Place Order",
      "data-cy": "confirm-place-order",
      "data-test": "confirm-place-order",
      "data-testid": "confirm-place-order",
      onClick: function onClick() {
        onConfirm(true);
      },
      m: "13px auto 30px",
      p: "0 30px"
    }, "Confirm"), __jsx(Link, {
      onClick: function onClick() {
        onConfirm(false);
      }
    }, "It's wrong! I need to fix it.")), __jsx(StyledModalClose, {
      onClick: function onClick() {
        return onConfirm(false);
      }
    }));
  });
});
export default PhoneNumberConfirmationModal;
var ModalContent = styled.div.withConfig({
  displayName: "phone-number-confirmation__ModalContent",
  componentId: "sc-12e6g0y-0"
})(["overflow:hidden;width:100%;padding:0 45px;text-align:center;background:#fff;"]);
var StyledModalHeader = styled.h3.withConfig({
  displayName: "phone-number-confirmation__StyledModalHeader",
  componentId: "sc-12e6g0y-1"
})(["font-size:15px;line-height:18px;font-weight:bold;padding-bottom:18px;color:#47494c;margin-top:10px;"]);
var StyledText = styled(Text).withConfig({
  displayName: "phone-number-confirmation__StyledText",
  componentId: "sc-12e6g0y-2"
})(["font-size:13px;line-height:20px;color:#6d747b;padding-bottom:28px;max-width:346px;margin:0 auto !important;"]);
var LargeText = styled(Text).withConfig({
  displayName: "phone-number-confirmation__LargeText",
  componentId: "sc-12e6g0y-3"
})(["font-size:24px;line-height:28px;color:#47494c;font-weight:bold;"]);
var Link = styled.button.withConfig({
  displayName: "phone-number-confirmation__Link",
  componentId: "sc-12e6g0y-4"
})(["appearance:none;border:none;padding:0;background-color:transparent;font-size:13px;cursor:pointer;"]);
var StyledModalButton = styled(ModalButton).withConfig({
  displayName: "phone-number-confirmation__StyledModalButton",
  componentId: "sc-12e6g0y-5"
})(["font-size:13px;"]);
var StyledModalClose = styled(ModalClose).withConfig({
  displayName: "phone-number-confirmation__StyledModalClose",
  componentId: "sc-12e6g0y-6"
})(["&:before,&:after{background-color:#000;}"]);